import EventEmitter from 'eventemitter3';
export var eventbus = new EventEmitter();
